import { useState } from "react";
import { StyledModal } from "../../../components/Modal";
import { FormButton } from "../operator-subcontractors-detail-edite/components/form-button";
import { FormsWraper } from "../operator-subcontractors-detail-edite/components/forms-wraper";




interface OperatorSubcontractorDetailEditProps {
    open: boolean,
    handleOpen: () => void,
    handleClose: () => void,
    forms: React.ReactNode[]; //Macierz z komponentami będącymi komponentami formularza odpowienio do nazw z "buttonName"
}



export const OperatorSubcontractorServicesEdit = ({ open, handleOpen, handleClose, forms }: OperatorSubcontractorDetailEditProps) => {


    const [value, setValue] = useState(0); //Od której zakładki startujemy
    const handleChangeButton = (event: unknown, newValue: number) => {
        setValue(newValue);
    };

    const buttonName: string[] = ["Dane"]; //Nazwy zakładek

    return (
        <StyledModal
            modalIsOpen={open}
            handleModalClose={handleClose}
        >
            <FormButton value={value}
                handleChangeButton={handleChangeButton}
                buttonName={buttonName}
            />
            <FormsWraper
                value={value}
                buttonName={buttonName}
                forms={forms}
            />

        </StyledModal>

    )
};
